import './Pill.scss';

export { default } from './Pill';
